/**
 * @file tool to dynamically load data from files
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import win11_5_03CustomFeatureDependencies from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_4_12CustomFeatureDependencies from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_4_09CustomFeatureDependencies from '../assets/MSTR11_4_09/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_4_06CustomFeatureDependencies from '../assets/MSTR11_4_06/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_4_03CustomFeatureDependencies from '../assets/MSTR11_4_03/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_3_12CustomFeatureDependencies from '../assets/MSTR11_3_12/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_3_11CustomFeatureDependencies from '../assets/MSTR11_3_11/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_3_10CustomFeatureDependencies from '../assets/MSTR11_3_10/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_3_9CustomFeatureDependencies from '../assets/MSTR11_3_9/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_3_8CustomFeatureDependencies from '../assets/MSTR11_3_8/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_3_7CustomFeatureDependencies from '../assets/MSTR11_3_7/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_3_6CustomFeatureDependencies from '../assets/MSTR11_3_6/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_3_5CustomFeatureDependencies from '../assets/MSTR11_3_5/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win11_3_4CustomFeatureDependencies from '../assets/MSTR11_3_4/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';
import win21CustomFeatureDependencies from '../assets/MSTR2021/WINDOWS_CUSTOM/Win21CustomFeatureDependencies.json';

import win11_5_03CustomComment from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_5_03ExpressComment from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_4_12CustomComment from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_4_12ExpressComment from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_4_09CustomComment from '../assets/MSTR11_4_09/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_4_09ExpressComment from '../assets/MSTR11_4_09/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_4_06CustomComment from '../assets/MSTR11_4_06/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_4_06ExpressComment from '../assets/MSTR11_4_06/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_4_03CustomComment from '../assets/MSTR11_4_03/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_4_03ExpressComment from '../assets/MSTR11_4_03/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_3_12CustomComment from '../assets/MSTR11_3_12/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_3_12ExpressComment from '../assets/MSTR11_3_12/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_3_11CustomComment from '../assets/MSTR11_3_11/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_3_11ExpressComment from '../assets/MSTR11_3_11/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_3_10CustomComment from '../assets/MSTR11_3_10/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_3_10ExpressComment from '../assets/MSTR11_3_10/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_3_9CustomComment from '../assets/MSTR11_3_9/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_3_9ExpressComment from '../assets/MSTR11_3_9/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_3_8CustomComment from '../assets/MSTR11_3_8/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_3_8ExpressComment from '../assets/MSTR11_3_8/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_3_7CustomComment from '../assets/MSTR11_3_7/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_3_7ExpressComment from '../assets/MSTR11_3_7/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_3_6CustomComment from '../assets/MSTR11_3_6/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_3_6ExpressComment from '../assets/MSTR11_3_6/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_3_5CustomComment from '../assets/MSTR11_3_5/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_3_5ExpressComment from '../assets/MSTR11_3_5/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win11_3_4CustomComment from '../assets/MSTR11_3_4/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win11_3_4ExpressComment from '../assets/MSTR11_3_4/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win21CustomComment from '../assets/MSTR2021/WINDOWS_CUSTOM/Win21CustomGeneratorComment';
import win21ExpressComment from '../assets/MSTR2021/WINDOWS_EXPRESS/Win21ExpressGeneratorComment';
import win21Update1Comment from '../assets/MSTR2021/WINDOWS_UPDATES/Win21Update1GeneratorComment';

import {
    featureKey2StateMap as win11_5_03CustomFeatureKey2StateMap,
    pic2StateMap as win11_5_03CustomPic2StateMap,
} from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_4_12CustomFeatureKey2StateMap,
    pic2StateMap as win11_4_12CustomPic2StateMap,
} from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_4_09CustomFeatureKey2StateMap,
    pic2StateMap as win11_4_09CustomPic2StateMap,
} from '../assets/MSTR11_4_09/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_4_06CustomFeatureKey2StateMap,
    pic2StateMap as win11_4_06CustomPic2StateMap,
} from '../assets/MSTR11_4_06/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_4_03CustomFeatureKey2StateMap,
    pic2StateMap as win11_4_03CustomPic2StateMap,
} from '../assets/MSTR11_4_03/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_3_12CustomFeatureKey2StateMap,
    pic2StateMap as win11_3_12CustomPic2StateMap,
} from '../assets/MSTR11_3_12/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_3_11CustomFeatureKey2StateMap,
    pic2StateMap as win11_3_11CustomPic2StateMap,
} from '../assets/MSTR11_3_11/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_3_10CustomFeatureKey2StateMap,
    pic2StateMap as win11_3_10CustomPic2StateMap,
} from '../assets/MSTR11_3_10/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_3_9CustomFeatureKey2StateMap,
    pic2StateMap as win11_3_9CustomPic2StateMap,
} from '../assets/MSTR11_3_9/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_3_8CustomFeatureKey2StateMap,
    pic2StateMap as win11_3_8CustomPic2StateMap,
} from '../assets/MSTR11_3_8/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_3_7CustomFeatureKey2StateMap,
    pic2StateMap as win11_3_7CustomPic2StateMap,
} from '../assets/MSTR11_3_7/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_3_6CustomFeatureKey2StateMap,
    pic2StateMap as win11_3_6CustomPic2StateMap,
} from '../assets/MSTR11_3_6/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_3_5CustomFeatureKey2StateMap,
    pic2StateMap as win11_3_5CustomPic2StateMap,
} from '../assets/MSTR11_3_5/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win11_3_4CustomFeatureKey2StateMap,
    pic2StateMap as win11_3_4CustomPic2StateMap,
} from '../assets/MSTR11_3_4/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    featureKey2StateMap as win21CustomFeatureKey2StateMap,
    pic2StateMap as win21CustomPic2StateMap,
} from '../assets/MSTR2021/WINDOWS_CUSTOM/Win21CustomMaps';

import {
    state2PrefixMap as win11_5_03ExpressState2PrefixMap,
    state2CommentMap as win11_5_03ExpressState2CommentMap,
} from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_5_03CustomState2PrefixMap,
    state2CommentMap as win11_5_03CustomState2CommentMap,
} from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_4_12ExpressState2PrefixMap,
    state2CommentMap as win11_4_12ExpressState2CommentMap,
} from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_4_12CustomState2PrefixMap,
    state2CommentMap as win11_4_12CustomState2CommentMap,
} from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_4_09ExpressState2PrefixMap,
    state2CommentMap as win11_4_09ExpressState2CommentMap,
} from '../assets/MSTR11_4_09/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_4_09CustomState2PrefixMap,
    state2CommentMap as win11_4_09CustomState2CommentMap,
} from '../assets/MSTR11_4_09/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_4_06ExpressState2PrefixMap,
    state2CommentMap as win11_4_06ExpressState2CommentMap,
} from '../assets/MSTR11_4_06/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_4_06CustomState2PrefixMap,
    state2CommentMap as win11_4_06CustomState2CommentMap,
} from '../assets/MSTR11_4_06/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_4_03ExpressState2PrefixMap,
    state2CommentMap as win11_4_03ExpressState2CommentMap,
} from '../assets/MSTR11_4_03/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_4_03CustomState2PrefixMap,
    state2CommentMap as win11_4_03CustomState2CommentMap,
} from '../assets/MSTR11_4_03/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_3_12ExpressState2PrefixMap,
    state2CommentMap as win11_3_12ExpressState2CommentMap,
} from '../assets/MSTR11_3_12/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_3_12CustomState2PrefixMap,
    state2CommentMap as win11_3_12CustomState2CommentMap,
} from '../assets/MSTR11_3_12/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_3_11ExpressState2PrefixMap,
    state2CommentMap as win11_3_11ExpressState2CommentMap,
} from '../assets/MSTR11_3_11/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_3_11CustomState2PrefixMap,
    state2CommentMap as win11_3_11CustomState2CommentMap,
} from '../assets/MSTR11_3_11/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_3_10ExpressState2PrefixMap,
    state2CommentMap as win11_3_10ExpressState2CommentMap,
} from '../assets/MSTR11_3_10/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_3_10CustomState2PrefixMap,
    state2CommentMap as win11_3_10CustomState2CommentMap,
} from '../assets/MSTR11_3_10/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_3_9ExpressState2PrefixMap,
    state2CommentMap as win11_3_9ExpressState2CommentMap,
} from '../assets/MSTR11_3_9/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_3_9CustomState2PrefixMap,
    state2CommentMap as win11_3_9CustomState2CommentMap,
} from '../assets/MSTR11_3_9/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win11_3_8ExpressState2PrefixMap,
    state2CommentMap as win11_3_8ExpressState2CommentMap,
} from '../assets/MSTR11_3_8/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_3_8CustomState2PrefixMap,
    state2CommentMap as win11_3_8CustomState2CommentMap,
} from '../assets/MSTR11_3_8/WINDOWS_CUSTOM/Win21CustomMaps4Generator';
import {
    state2PrefixMap as win11_3_7ExpressState2PrefixMap,
    state2CommentMap as win11_3_7ExpressState2CommentMap,
} from '../assets/MSTR11_3_7/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_3_7CustomState2PrefixMap,
    state2CommentMap as win11_3_7CustomState2CommentMap,
} from '../assets/MSTR11_3_7/WINDOWS_CUSTOM/Win21CustomMaps4Generator';
import {
    state2PrefixMap as win11_3_6ExpressState2PrefixMap,
    state2CommentMap as win11_3_6ExpressState2CommentMap,
} from '../assets/MSTR11_3_6/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_3_6CustomState2PrefixMap,
    state2CommentMap as win11_3_6CustomState2CommentMap,
} from '../assets/MSTR11_3_6/WINDOWS_CUSTOM/Win21CustomMaps4Generator';
import {
    state2PrefixMap as win11_3_5ExpressState2PrefixMap,
    state2CommentMap as win11_3_5ExpressState2CommentMap,
} from '../assets/MSTR11_3_5/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_3_5CustomState2PrefixMap,
    state2CommentMap as win11_3_5CustomState2CommentMap,
} from '../assets/MSTR11_3_5/WINDOWS_CUSTOM/Win21CustomMaps4Generator';
import {
    state2PrefixMap as win11_3_4ExpressState2PrefixMap,
    state2CommentMap as win11_3_4ExpressState2CommentMap,
} from '../assets/MSTR11_3_4/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win11_3_4CustomState2PrefixMap,
    state2CommentMap as win11_3_4CustomState2CommentMap,
} from '../assets/MSTR11_3_4/WINDOWS_CUSTOM/Win21CustomMaps4Generator';
import {
    state2PrefixMap as win21ExpressState2PrefixMap,
    state2CommentMap as win21ExpressState2CommentMap,
} from '../assets/MSTR2021/WINDOWS_EXPRESS/Win21ExpressMaps4Generator';
import {
    state2PrefixMap as win21CustomState2PrefixMap,
    state2CommentMap as win21CustomState2CommentMap,
} from '../assets/MSTR2021/WINDOWS_CUSTOM/Win21CustomMaps4Generator';

import {
    state2PrefixMap as win21Update1State2PrefixMap,
    state2CommentMap as win21Update1State2CommentMap,
} from '../assets/MSTR2021/WINDOWS_UPDATES/Win21Update1Maps4Generator';

import win11_5_03CustomPageObjects from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_5_03ExpressPageObjects from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_4_12CustomPageObjects from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_4_12ExpressPageObjects from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_4_09CustomPageObjects from '../assets/MSTR11_4_09/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_4_09ExpressPageObjects from '../assets/MSTR11_4_09/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_4_06CustomPageObjects from '../assets/MSTR11_4_06/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_4_06ExpressPageObjects from '../assets/MSTR11_4_06/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_4_03CustomPageObjects from '../assets/MSTR11_4_03/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_4_03ExpressPageObjects from '../assets/MSTR11_4_03/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_3_12CustomPageObjects from '../assets/MSTR11_3_12/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_3_12ExpressPageObjects from '../assets/MSTR11_3_12/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_3_11CustomPageObjects from '../assets/MSTR11_3_11/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_3_11ExpressPageObjects from '../assets/MSTR11_3_11/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_3_10CustomPageObjects from '../assets/MSTR11_3_10/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_3_10ExpressPageObjects from '../assets/MSTR11_3_10/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_3_9CustomPageObjects from '../assets/MSTR11_3_9/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_3_9ExpressPageObjects from '../assets/MSTR11_3_9/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_3_8CustomPageObjects from '../assets/MSTR11_3_8/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_3_8ExpressPageObjects from '../assets/MSTR11_3_8/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_3_7CustomPageObjects from '../assets/MSTR11_3_7/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_3_7ExpressPageObjects from '../assets/MSTR11_3_7/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_3_6CustomPageObjects from '../assets/MSTR11_3_6/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_3_6ExpressPageObjects from '../assets/MSTR11_3_6/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_3_5CustomPageObjects from '../assets/MSTR11_3_5/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_3_5ExpressPageObjects from '../assets/MSTR11_3_5/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win11_3_4CustomPageObjects from '../assets/MSTR11_3_4/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win11_3_4ExpressPageObjects from '../assets/MSTR11_3_4/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win21CustomPageObjects from '../assets/MSTR2021/WINDOWS_CUSTOM/Win21CustomPageObjects.json';
import win21ExpressPageObjects from '../assets/MSTR2021/WINDOWS_EXPRESS/Win21ExpressPageObjects.json';
import win21Update1PageObjects from '../assets/MSTR2021/WINDOWS_UPDATES/Win21Update1PageObjects.json';

import win11_5_03CustomStates from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_5_03ExpressStates from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_4_12CustomStates from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_4_12ExpressStates from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_4_09CustomStates from '../assets/MSTR11_4_09/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_4_09ExpressStates from '../assets/MSTR11_4_09/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_4_06CustomStates from '../assets/MSTR11_4_06/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_4_06ExpressStates from '../assets/MSTR11_4_06/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_4_03CustomStates from '../assets/MSTR11_4_03/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_4_03ExpressStates from '../assets/MSTR11_4_03/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_3_12CustomStates from '../assets/MSTR11_3_12/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_3_12ExpressStates from '../assets/MSTR11_3_12/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_3_11CustomStates from '../assets/MSTR11_3_11/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_3_11ExpressStates from '../assets/MSTR11_3_11/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_3_10CustomStates from '../assets/MSTR11_3_10/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_3_10ExpressStates from '../assets/MSTR11_3_10/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_3_9CustomStates from '../assets/MSTR11_3_9/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_3_9ExpressStates from '../assets/MSTR11_3_9/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_3_8CustomStates from '../assets/MSTR11_3_8/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_3_8ExpressStates from '../assets/MSTR11_3_8/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_3_7CustomStates from '../assets/MSTR11_3_7/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_3_7ExpressStates from '../assets/MSTR11_3_7/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_3_6CustomStates from '../assets/MSTR11_3_6/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_3_6ExpressStates from '../assets/MSTR11_3_6/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_3_5CustomStates from '../assets/MSTR11_3_5/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_3_5ExpressStates from '../assets/MSTR11_3_5/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win11_3_4CustomStates from '../assets/MSTR11_3_4/WINDOWS_CUSTOM/Win21CustomStates.json';
import win11_3_4ExpressStates from '../assets/MSTR11_3_4/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win21CustomStates from '../assets/MSTR2021/WINDOWS_CUSTOM/Win21CustomStates.json';
import win21ExpressStates from '../assets/MSTR2021/WINDOWS_EXPRESS/Win21ExpressStates.json';
import win21Update1States from '../assets/MSTR2021/WINDOWS_UPDATES/Win21Update1States.json';

import win11_5_03CustomSummaryStructure from '../assets/MSTR11_5_03/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_5_03ExpressSummaryStructure from '../assets/MSTR11_5_03/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_4_12CustomSummaryStructure from '../assets/MSTR11_4_12/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_4_12ExpressSummaryStructure from '../assets/MSTR11_4_12/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_4_09CustomSummaryStructure from '../assets/MSTR11_4_09/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_4_09ExpressSummaryStructure from '../assets/MSTR11_4_09/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_4_06CustomSummaryStructure from '../assets/MSTR11_4_06/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_4_06ExpressSummaryStructure from '../assets/MSTR11_4_06/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_4_03CustomSummaryStructure from '../assets/MSTR11_4_03/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_4_03ExpressSummaryStructure from '../assets/MSTR11_4_03/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_3_12CustomSummaryStructure from '../assets/MSTR11_3_12/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_3_12ExpressSummaryStructure from '../assets/MSTR11_3_12/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_3_11CustomSummaryStructure from '../assets/MSTR11_3_11/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_3_11ExpressSummaryStructure from '../assets/MSTR11_3_11/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_3_10CustomSummaryStructure from '../assets/MSTR11_3_10/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_3_10ExpressSummaryStructure from '../assets/MSTR11_3_10/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_3_9CustomSummaryStructure from '../assets/MSTR11_3_9/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_3_9ExpressSummaryStructure from '../assets/MSTR11_3_9/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_3_8CustomSummaryStructure from '../assets/MSTR11_3_8/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_3_8ExpressSummaryStructure from '../assets/MSTR11_3_8/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_3_7CustomSummaryStructure from '../assets/MSTR11_3_7/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_3_7ExpressSummaryStructure from '../assets/MSTR11_3_7/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_3_6CustomSummaryStructure from '../assets/MSTR11_3_6/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_3_6ExpressSummaryStructure from '../assets/MSTR11_3_6/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_3_5CustomSummaryStructure from '../assets/MSTR11_3_5/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_3_5ExpressSummaryStructure from '../assets/MSTR11_3_5/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win11_3_4CustomSummaryStructure from '../assets/MSTR11_3_4/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win11_3_4ExpressSummaryStructure from '../assets/MSTR11_3_4/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';
import win21CustomSummaryStructure from '../assets/MSTR2021/WINDOWS_CUSTOM/Win21CustomSummaryStructure.json';
import win21ExpressSummaryStructure from '../assets/MSTR2021/WINDOWS_EXPRESS/Win21ExpressSummaryStructure.json';

import {
    WINDOWS_11_5_03_CUSTOM,
    WINDOWS_11_5_03_EXPRESS,
    WINDOWS_11_4_12_CUSTOM,
    WINDOWS_11_4_12_EXPRESS,
    WINDOWS_11_4_09_CUSTOM,
    WINDOWS_11_4_09_EXPRESS,
    WINDOWS_11_4_06_CUSTOM,
    WINDOWS_11_4_06_EXPRESS,
    WINDOWS_11_4_03_CUSTOM,
    WINDOWS_11_4_03_EXPRESS,
    WINDOWS_11_3_12_CUSTOM,
    WINDOWS_11_3_12_EXPRESS,    
    WINDOWS_11_3_11_CUSTOM,
    WINDOWS_11_3_11_EXPRESS,
    WINDOWS_11_3_10_CUSTOM,
    WINDOWS_11_3_10_EXPRESS,
    WINDOWS_11_3_9_CUSTOM,
    WINDOWS_11_3_9_EXPRESS,
    WINDOWS_11_3_8_CUSTOM,
    WINDOWS_11_3_8_EXPRESS,
    WINDOWS_11_3_7_CUSTOM,
    WINDOWS_11_3_7_EXPRESS,
    WINDOWS_11_3_6_CUSTOM,
    WINDOWS_11_3_6_EXPRESS,
    WINDOWS_11_3_5_2_CUSTOM,
    WINDOWS_11_3_5_2_EXPRESS,
    WINDOWS_11_3_5_1_CUSTOM,
    WINDOWS_11_3_5_1_EXPRESS,
    WINDOWS_11_3_5_CUSTOM,
    WINDOWS_11_3_5_EXPRESS,
    WINDOWS_11_3_4_1_CUSTOM,
    WINDOWS_11_3_4_1_EXPRESS,
    WINDOWS_11_3_4_CUSTOM,
    WINDOWS_11_3_4_EXPRESS,
    WINDOWS_21_CUSTOM,
    WINDOWS_21_EXPRESS,
    WINDOWS_21_UPDATE1,
    WINDOWS_21_UPDATE2,
    WINDOWS_21_UPDATE3,
} from '../Utils/Constants';

export let featureDependencies = win21CustomFeatureDependencies;
export let comment = win21CustomComment;
export let featureKey2StateMap = win21CustomFeatureKey2StateMap;
export let pic2StateMap = win21CustomPic2StateMap;
export let state2PrefixMap = win21CustomState2PrefixMap;
export let state2CommentMap = win21CustomState2CommentMap;
export let pageObjects = win21CustomPageObjects;
export let states = win21CustomStates;
export let summaryStructure = win21CustomSummaryStructure;

export const winLoadData = (installation) => {
    switch (installation) {
        case WINDOWS_11_5_03_CUSTOM:
            featureDependencies = win11_5_03CustomFeatureDependencies;
            comment = win11_5_03CustomComment;
            featureKey2StateMap = win11_5_03CustomFeatureKey2StateMap;
            pic2StateMap = win11_5_03CustomPic2StateMap;
            state2PrefixMap = win11_5_03CustomState2PrefixMap;
            state2CommentMap = win11_5_03CustomState2CommentMap;
            pageObjects = win11_5_03CustomPageObjects;
            states = win11_5_03CustomStates;
            summaryStructure = win11_5_03CustomSummaryStructure;
            break;
        case WINDOWS_11_4_12_CUSTOM:
            featureDependencies = win11_4_12CustomFeatureDependencies;
            comment = win11_4_12CustomComment;
            featureKey2StateMap = win11_4_12CustomFeatureKey2StateMap;
            pic2StateMap = win11_4_12CustomPic2StateMap;
            state2PrefixMap = win11_4_12CustomState2PrefixMap;
            state2CommentMap = win11_4_12CustomState2CommentMap;
            pageObjects = win11_4_12CustomPageObjects;
            states = win11_4_12CustomStates;
            summaryStructure = win11_4_12CustomSummaryStructure;
            break;
        case WINDOWS_11_4_09_CUSTOM:
            featureDependencies = win11_4_09CustomFeatureDependencies;
            comment = win11_4_09CustomComment;
            featureKey2StateMap = win11_4_09CustomFeatureKey2StateMap;
            pic2StateMap = win11_4_09CustomPic2StateMap;
            state2PrefixMap = win11_4_09CustomState2PrefixMap;
            state2CommentMap = win11_4_09CustomState2CommentMap;
            pageObjects = win11_4_09CustomPageObjects;
            states = win11_4_09CustomStates;
            summaryStructure = win11_4_09CustomSummaryStructure;
            break;
        case WINDOWS_11_4_06_CUSTOM:
            featureDependencies = win11_4_06CustomFeatureDependencies;
            comment = win11_4_06CustomComment;
            featureKey2StateMap = win11_4_06CustomFeatureKey2StateMap;
            pic2StateMap = win11_4_06CustomPic2StateMap;
            state2PrefixMap = win11_4_06CustomState2PrefixMap;
            state2CommentMap = win11_4_06CustomState2CommentMap;
            pageObjects = win11_4_06CustomPageObjects;
            states = win11_4_06CustomStates;
            summaryStructure = win11_4_06CustomSummaryStructure;
            break;
        case WINDOWS_11_4_03_CUSTOM:
            featureDependencies = win11_4_03CustomFeatureDependencies;
            comment = win11_4_03CustomComment;
            featureKey2StateMap = win11_4_03CustomFeatureKey2StateMap;
            pic2StateMap = win11_4_03CustomPic2StateMap;
            state2PrefixMap = win11_4_03CustomState2PrefixMap;
            state2CommentMap = win11_4_03CustomState2CommentMap;
            pageObjects = win11_4_03CustomPageObjects;
            states = win11_4_03CustomStates;
            summaryStructure = win11_4_03CustomSummaryStructure;
            break;
        case WINDOWS_11_3_12_CUSTOM:
            featureDependencies = win11_3_12CustomFeatureDependencies;
            comment = win11_3_12CustomComment;
            featureKey2StateMap = win11_3_12CustomFeatureKey2StateMap;
            pic2StateMap = win11_3_12CustomPic2StateMap;
            state2PrefixMap = win11_3_12CustomState2PrefixMap;
            state2CommentMap = win11_3_12CustomState2CommentMap;
            pageObjects = win11_3_12CustomPageObjects;
            states = win11_3_12CustomStates;
            summaryStructure = win11_3_12CustomSummaryStructure;
            break;        
        case WINDOWS_11_3_11_CUSTOM:
            featureDependencies = win11_3_11CustomFeatureDependencies;
            comment = win11_3_11CustomComment;
            featureKey2StateMap = win11_3_11CustomFeatureKey2StateMap;
            pic2StateMap = win11_3_11CustomPic2StateMap;
            state2PrefixMap = win11_3_11CustomState2PrefixMap;
            state2CommentMap = win11_3_11CustomState2CommentMap;
            pageObjects = win11_3_11CustomPageObjects;
            states = win11_3_11CustomStates;
            summaryStructure = win11_3_11CustomSummaryStructure;
            break;
        case WINDOWS_11_3_10_CUSTOM:
            featureDependencies = win11_3_10CustomFeatureDependencies;
            comment = win11_3_10CustomComment;
            featureKey2StateMap = win11_3_10CustomFeatureKey2StateMap;
            pic2StateMap = win11_3_10CustomPic2StateMap;
            state2PrefixMap = win11_3_10CustomState2PrefixMap;
            state2CommentMap = win11_3_10CustomState2CommentMap;
            pageObjects = win11_3_10CustomPageObjects;
            states = win11_3_10CustomStates;
            summaryStructure = win11_3_10CustomSummaryStructure;
            break;
        case WINDOWS_11_3_9_CUSTOM:
            featureDependencies = win11_3_9CustomFeatureDependencies;
            comment = win11_3_9CustomComment;
            featureKey2StateMap = win11_3_9CustomFeatureKey2StateMap;
            pic2StateMap = win11_3_9CustomPic2StateMap;
            state2PrefixMap = win11_3_9CustomState2PrefixMap;
            state2CommentMap = win11_3_9CustomState2CommentMap;
            pageObjects = win11_3_9CustomPageObjects;
            states = win11_3_9CustomStates;
            summaryStructure = win11_3_9CustomSummaryStructure;
            break;
        case WINDOWS_11_3_8_CUSTOM:
            featureDependencies = win11_3_8CustomFeatureDependencies;
            comment = win11_3_8CustomComment;
            featureKey2StateMap = win11_3_8CustomFeatureKey2StateMap;
            pic2StateMap = win11_3_8CustomPic2StateMap;
            state2PrefixMap = win11_3_8CustomState2PrefixMap;
            state2CommentMap = win11_3_8CustomState2CommentMap;
            pageObjects = win11_3_8CustomPageObjects;
            states = win11_3_8CustomStates;
            summaryStructure = win11_3_8CustomSummaryStructure;
            break;
        case WINDOWS_11_3_7_CUSTOM:
            featureDependencies = win11_3_7CustomFeatureDependencies;
            comment = win11_3_7CustomComment;
            featureKey2StateMap = win11_3_7CustomFeatureKey2StateMap;
            pic2StateMap = win11_3_7CustomPic2StateMap;
            state2PrefixMap = win11_3_7CustomState2PrefixMap;
            state2CommentMap = win11_3_7CustomState2CommentMap;
            pageObjects = win11_3_7CustomPageObjects;
            states = win11_3_7CustomStates;
            summaryStructure = win11_3_7CustomSummaryStructure;
            break;
        case WINDOWS_11_3_6_CUSTOM:
            featureDependencies = win11_3_6CustomFeatureDependencies;
            comment = win11_3_6CustomComment;
            featureKey2StateMap = win11_3_6CustomFeatureKey2StateMap;
            pic2StateMap = win11_3_6CustomPic2StateMap;
            state2PrefixMap = win11_3_6CustomState2PrefixMap;
            state2CommentMap = win11_3_6CustomState2CommentMap;
            pageObjects = win11_3_6CustomPageObjects;
            states = win11_3_6CustomStates;
            summaryStructure = win11_3_6CustomSummaryStructure;
            break;
        case WINDOWS_11_3_5_2_CUSTOM:
        case WINDOWS_11_3_5_1_CUSTOM:
        case WINDOWS_11_3_5_CUSTOM:
            featureDependencies = win11_3_5CustomFeatureDependencies;
            comment = win11_3_5CustomComment;
            featureKey2StateMap = win11_3_5CustomFeatureKey2StateMap;
            pic2StateMap = win11_3_5CustomPic2StateMap;
            state2PrefixMap = win11_3_5CustomState2PrefixMap;
            state2CommentMap = win11_3_5CustomState2CommentMap;
            pageObjects = win11_3_5CustomPageObjects;
            states = win11_3_5CustomStates;
            summaryStructure = win11_3_5CustomSummaryStructure;
            break;
        case WINDOWS_11_3_4_1_CUSTOM:
        case WINDOWS_11_3_4_CUSTOM:
            featureDependencies = win11_3_4CustomFeatureDependencies;
            comment = win11_3_4CustomComment;
            featureKey2StateMap = win11_3_4CustomFeatureKey2StateMap;
            pic2StateMap = win11_3_4CustomPic2StateMap;
            state2PrefixMap = win11_3_4CustomState2PrefixMap;
            state2CommentMap = win11_3_4CustomState2CommentMap;
            pageObjects = win11_3_4CustomPageObjects;
            states = win11_3_4CustomStates;
            summaryStructure = win11_3_4CustomSummaryStructure;
            break;

        case WINDOWS_11_5_03_EXPRESS:
            comment = win11_5_03ExpressComment;
            state2PrefixMap = win11_5_03ExpressState2PrefixMap;
            state2CommentMap = win11_5_03ExpressState2CommentMap;
            pageObjects = win11_5_03ExpressPageObjects;
            states = win11_5_03ExpressStates;
            summaryStructure = win11_5_03ExpressSummaryStructure;
            break;
        case WINDOWS_11_4_12_EXPRESS:
            comment = win11_4_12ExpressComment;
            state2PrefixMap = win11_4_12ExpressState2PrefixMap;
            state2CommentMap = win11_4_12ExpressState2CommentMap;
            pageObjects = win11_4_12ExpressPageObjects;
            states = win11_4_12ExpressStates;
            summaryStructure = win11_4_12ExpressSummaryStructure;
            break;
        case WINDOWS_11_4_09_EXPRESS:
            comment = win11_4_09ExpressComment;
            state2PrefixMap = win11_4_09ExpressState2PrefixMap;
            state2CommentMap = win11_4_09ExpressState2CommentMap;
            pageObjects = win11_4_09ExpressPageObjects;
            states = win11_4_09ExpressStates;
            summaryStructure = win11_4_09ExpressSummaryStructure;
            break;
        case WINDOWS_11_4_06_EXPRESS:
            comment = win11_4_06ExpressComment;
            state2PrefixMap = win11_4_06ExpressState2PrefixMap;
            state2CommentMap = win11_4_06ExpressState2CommentMap;
            pageObjects = win11_4_06ExpressPageObjects;
            states = win11_4_06ExpressStates;
            summaryStructure = win11_4_06ExpressSummaryStructure;
            break;
        case WINDOWS_11_4_03_EXPRESS:
            comment = win11_4_03ExpressComment;
            state2PrefixMap = win11_4_03ExpressState2PrefixMap;
            state2CommentMap = win11_4_03ExpressState2CommentMap;
            pageObjects = win11_4_03ExpressPageObjects;
            states = win11_4_03ExpressStates;
            summaryStructure = win11_4_03ExpressSummaryStructure;
            break;
        case WINDOWS_11_3_12_EXPRESS:
            comment = win11_3_12ExpressComment;
            state2PrefixMap = win11_3_12ExpressState2PrefixMap;
            state2CommentMap = win11_3_12ExpressState2CommentMap;
            pageObjects = win11_3_12ExpressPageObjects;
            states = win11_3_12ExpressStates;
            summaryStructure = win11_3_12ExpressSummaryStructure;
            break;
        case WINDOWS_11_3_11_EXPRESS:
            comment = win11_3_11ExpressComment;
            state2PrefixMap = win11_3_11ExpressState2PrefixMap;
            state2CommentMap = win11_3_11ExpressState2CommentMap;
            pageObjects = win11_3_11ExpressPageObjects;
            states = win11_3_11ExpressStates;
            summaryStructure = win11_3_11ExpressSummaryStructure;
            break;
        case WINDOWS_11_3_10_EXPRESS:
            comment = win11_3_10ExpressComment;
            state2PrefixMap = win11_3_10ExpressState2PrefixMap;
            state2CommentMap = win11_3_10ExpressState2CommentMap;
            pageObjects = win11_3_10ExpressPageObjects;
            states = win11_3_10ExpressStates;
            summaryStructure = win11_3_10ExpressSummaryStructure;
            break;
        case WINDOWS_11_3_9_EXPRESS:
            comment = win11_3_9ExpressComment;
            state2PrefixMap = win11_3_9ExpressState2PrefixMap;
            state2CommentMap = win11_3_9ExpressState2CommentMap;
            pageObjects = win11_3_9ExpressPageObjects;
            states = win11_3_9ExpressStates;
            summaryStructure = win11_3_9ExpressSummaryStructure;
            break;    
        case WINDOWS_11_3_8_EXPRESS:
            comment = win11_3_8ExpressComment;
            state2PrefixMap = win11_3_8ExpressState2PrefixMap;
            state2CommentMap = win11_3_8ExpressState2CommentMap;
            pageObjects = win11_3_8ExpressPageObjects;
            states = win11_3_8ExpressStates;
            summaryStructure = win11_3_8ExpressSummaryStructure;
            break;
        case WINDOWS_11_3_7_EXPRESS:
            comment = win11_3_7ExpressComment;
            state2PrefixMap = win11_3_7ExpressState2PrefixMap;
            state2CommentMap = win11_3_7ExpressState2CommentMap;
            pageObjects = win11_3_7ExpressPageObjects;
            states = win11_3_7ExpressStates;
            summaryStructure = win11_3_7ExpressSummaryStructure;
            break;
        case WINDOWS_11_3_6_EXPRESS:
            comment = win11_3_6ExpressComment;
            state2PrefixMap = win11_3_6ExpressState2PrefixMap;
            state2CommentMap = win11_3_6ExpressState2CommentMap;
            pageObjects = win11_3_6ExpressPageObjects;
            states = win11_3_6ExpressStates;
            summaryStructure = win11_3_6ExpressSummaryStructure;
            break;
        case WINDOWS_11_3_5_2_EXPRESS:
        case WINDOWS_11_3_5_1_EXPRESS:
        case WINDOWS_11_3_5_EXPRESS:
            comment = win11_3_5ExpressComment;
            state2PrefixMap = win11_3_5ExpressState2PrefixMap;
            state2CommentMap = win11_3_5ExpressState2CommentMap;
            pageObjects = win11_3_5ExpressPageObjects;
            states = win11_3_5ExpressStates;
            summaryStructure = win11_3_5ExpressSummaryStructure;
            break;
        case WINDOWS_11_3_4_1_EXPRESS:
        case WINDOWS_11_3_4_EXPRESS:
            comment = win11_3_4ExpressComment;
            state2PrefixMap = win11_3_4ExpressState2PrefixMap;
            state2CommentMap = win11_3_4ExpressState2CommentMap;
            pageObjects = win11_3_4ExpressPageObjects;
            states = win11_3_4ExpressStates;
            summaryStructure = win11_3_4ExpressSummaryStructure;
            break;
        case WINDOWS_21_CUSTOM:
            featureDependencies = win21CustomFeatureDependencies;
            comment = win21CustomComment;
            featureKey2StateMap = win21CustomFeatureKey2StateMap;
            pic2StateMap = win21CustomPic2StateMap;
            state2PrefixMap = win21CustomState2PrefixMap;
            state2CommentMap = win21CustomState2CommentMap;
            pageObjects = win21CustomPageObjects;
            states = win21CustomStates;
            summaryStructure = win21CustomSummaryStructure;
            break;
        case WINDOWS_21_EXPRESS:
            comment = win21ExpressComment;
            state2PrefixMap = win21ExpressState2PrefixMap;
            state2CommentMap = win21ExpressState2CommentMap;
            pageObjects = win21ExpressPageObjects;
            states = win21ExpressStates;
            summaryStructure = win21ExpressSummaryStructure;
            break;
        case WINDOWS_21_UPDATE1:
        case WINDOWS_21_UPDATE2:
        case WINDOWS_21_UPDATE3:
            comment = win21Update1Comment;
            state2PrefixMap = win21Update1State2PrefixMap;
            state2CommentMap = win21Update1State2CommentMap;
            pageObjects = win21Update1PageObjects;
            states = win21Update1States;
            break;

        default:
    }
};
